var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "module-related-list" }, [
    _c("div", { staticClass: "module-related-list__container" }, [
      _vm.modules.length > 0
        ? _c(
            "div",
            { staticClass: "module-related-list__menu" },
            _vm._l(_vm.modules, function (module) {
              return _c(
                "div",
                {
                  key: module.id,
                  staticClass: "module-related-list__menu-item",
                  class: {
                    selected:
                      _vm.$_.get(_vm.selectedModule, "moduleName") ===
                      module.moduleName,
                  },
                  on: {
                    click: function ($event) {
                      _vm.selectedModule = module
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v(_vm._s(module.icon || "list")),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(module.displayName))]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modules.length > 0
        ? _c(
            "div",
            {
              key: _vm.$_.get(_vm.selectedModule, "moduleName"),
              staticClass: "module-related-list__content",
            },
            [
              _vm.selectedModule
                ? _c(
                    "div",
                    { staticClass: "module-related-list__content-inner" },
                    [
                      _c("TableDetail", {
                        attrs: {
                          defaultRecords: _vm.records,
                          moduleMode: true,
                          defaultTableId:
                            _vm.selectedModule.relation.tableToTable.to.table,
                          predefinedValues: _vm.getTablePredefinedValues(),
                          "default-linked-record-cache":
                            _vm.getLinkedRecordCache(),
                          "implicit-filters": _vm.getImplicitFilters(),
                        },
                        on: { "record-created": _vm.onRecordCreated },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }